import React, { Component } from 'react';

import './style.css';
class PolicyPage extends Component {
  render() {
    return (
      <div>

        <center>
			<div id="header0">PRIVACY POLICY</div>
			<div id="content0">Secure Pass application</div>
			<div id="content0">Last modified on June 30, 2021</div>
		</center>
		
		<div id="content2">
		We do not collect any your data. All permissons which we request only purpose for application's functions.
		All permissions of this app are describe as below:
		</div>
		
		<div id="header2">INTERNET</div>
        <div id="content2">
		It allows application get new configurations.
		</div>
		
		<div id="header2">Changes</div>
        <div id="content2">
		We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.	
		</div>
		
		<div id="header2">Contact Us</div>
        <div id="content2">
		If you have any questions, or to report any violations of the Policy, please contact us at reping.dev@gmail.com.
		</div>
      </div>
    );
  }
}

export default PolicyPage;



// WEBPACK FOOTER //
// ./src/Privacy Policy/SecurePass/index.js